import React from "react";

import { Button } from "components";
import { LineDivider, FormTitle } from "components/layout";
import { EnumDto } from "types";

import { ProcessorSpecificSection } from "./processorSpecificSection";

import styles from "./processorSpecific.module.scss";

type ProcessorSpecificProps = {
	loading: boolean;
	formName: string;
	fields: any;
	fdOmahaProcessorTypes: EnumDto[];
	processorSpecific: any;
	deleteLegacyInformation: any;
};

export const ProcessorSpecificFieldArray = ({
	loading,
	formName,
	fields,
	fdOmahaProcessorTypes,
	processorSpecific,
	deleteLegacyInformation,
}: ProcessorSpecificProps) => {
	return (
		<>
			{fields.length === 0 && (
				<FormTitle>
					<h3>Processor Specific</h3>
				</FormTitle>
			)}
			{fields.map((name, index) => {
				return (
					<div key={index} className="position-relative">
						{fields.length > 0 && index > 0 && <LineDivider />}
						<ProcessorSpecificSection
							remove={fields.remove}
							length={fields.length}
							index={index}
							name={name}
							loading={loading}
							formName={formName}
							fdOmahaProcessorTypes={fdOmahaProcessorTypes}
							processorSpecific={processorSpecific}
							deleteLegacyInformation={deleteLegacyInformation}
						/>
					</div>
				);
			})}
			<Button
				variant="secondary"
				value="Add Processor"
				onClick={() => fields.push({})}
				className={styles.btnAdd}
			/>
		</>
	);
};

